import React from 'react';
import PageHero from '../components/PageHero';
import BackButton from '../components/BackButton';
import Pricing from '../components/Pricing';

function PricingPage() {
  return (
    <>
      <PageHero
        label="Private AI"
        title="Pricing"
        subtitle="One setup fee. One monthly rate. Your model, your servers, your data."
      />
      <BackButton />
      <Pricing />
    </>
  );
}

export default PricingPage;
